// src/components/worldrated/WorldRated_container.js
import { connect } from "react-redux";
import WorldRated from "./WorldRated";
import {
  fetchAllHotels,
  setHotelsSelection,
  setHotelsViewMode,
} from "../../actions/hotel_actions";

// ---- helpers to derive lists from items + selection
const unique = (arr) => Array.from(new Set(arr.filter(Boolean)));

const mapStateToProps = (state) => {
  const items = state.hotels?.items || [];
  const selection = state.hotels?.selection || { continent: null, country: null, city: null };
  const viewMode = state.hotels?.viewMode || "hierarchy";

  const continents = unique(items.map(h => h.continent));
  const countries = selection.continent
    ? unique(items.filter(h => h.continent === selection.continent).map(h => h.country))
    : [];
  const cities = selection.continent && selection.country
    ? unique(items
        .filter(h => h.continent === selection.continent && h.country === selection.country)
        .map(h => h.city))
    : [];

  const hotels = selection.continent && selection.country && selection.city
    ? items.filter(h =>
        h.continent === selection.continent &&
        h.country === selection.country &&
        h.city === selection.city
      )
    : [];

  const hotelsAtoZ = items.slice().sort((a, b) => (a.name || "").localeCompare(b.name || ""));

  return {
    items,
    loading: state.hotels?.loading || false,
    error: state.hotels?.error || null,
    selection,
    viewMode,
    continents,
    countries,
    cities,
    hotels,
    hotelsAtoZ,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchAllHotels: () => dispatch(fetchAllHotels()),

  onSelectContinent: (continent) =>
    dispatch(setHotelsSelection({ continent, country: null, city: null })),

  onSelectCountry: (country, continent) =>
    dispatch(setHotelsSelection({ continent, country, city: null })),

  onSelectCity: (city, continent, country) =>
    dispatch(setHotelsSelection({ continent, country, city })),

  onSetViewMode: (mode) => dispatch(setHotelsViewMode(mode)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WorldRated);
